import { $t } from '@/i18n';
import axios from 'axios';
import { getBaseURL } from './wujiWindow';
export async function wujiRequest(params) {
    const response = await axios({
        baseURL: getBaseURL(),
        withCredentials: true,
        ...params,
    });
    if (response.status !== 200)
        throw new Error(`${response.status}: ${response.statusText}`);
    const { data } = response;
    if (!data)
        throw new Error($t('k_8ac70fc4'));
    if (data.code !== 200)
        throw new Error(data.error || data.message || $t('k_c4097d2'));
    return data.data;
}
